import { render } from "./ServiceList.vue?vue&type=template&id=9119e556&scoped=true"
import script from "../js/service.js?vue&type=script&lang=js"
export * from "../js/service.js?vue&type=script&lang=js"

import "./ServiceList.vue?vue&type=style&index=0&id=9119e556&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/platinum-landscape/platinum-landscape-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9119e556"]])

export default __exports__